import { z } from 'zod';
import { requiredStringSchema } from '../../../utils/validationSchemas';

/**
 * Validation schema for a single offer position
 * Used in request creation forms
 */
export const offerPositionSchema = z.object({
    productName: requiredStringSchema('Product name'),
    brand: z.string().optional(),
    description: z.string().optional(),
    price: z.coerce.number().positive('Price must be greater than 0'),
    quantity: z.coerce.number().int().positive().min(1, 'Quantity must be at least 1'),
    deliveryTime: z.string().nullable().optional(),
    notes: z.string().optional(),
    productCode: z.string().optional(),
    supplier: z.string().optional(),
    images: z.array(z.any()).optional(),
});

export type OfferPositionFormData = z.infer<typeof offerPositionSchema>;

/**
 * Default values for a new offer position
 */
export const defaultOfferPosition: OfferPositionFormData = {
    productName: '',
    brand: '',
    description: '',
    price: '' as any, // Empty string to avoid validation error on 0
    quantity: 1,
    deliveryTime: null,
    notes: '',
    productCode: '',
    supplier: '',
    images: [],
};

